import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';

import { Sorting } from 'src/components/Sorting';

import { getSortField, getSortOrder } from '../../selectors/sorting';
import { isAwaitingFiltration } from '../../searchStatus/selectors';
import { isExpandedMapSelector } from '../../store/map/selectors';

import { changeSortingAction } from '../../actions/sorting';

const mapStateToProps = (state) => ({
  field: getSortField(state),
  order: getSortOrder(state),
  awaitFiltration: isAwaitingFiltration(state),
  isMobile: getIsMobile(state),
  isMapView: isExpandedMapSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  changeSorting: (payload) => dispatch(changeSortingAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sorting);
